import React from 'react';
import styled from 'styled-components';
export const Spinner = styled.div `
  margin: auto;
  width: 50px;
  height: 40px;
  font-size: ${(props) => props.theme.fontXXXSmall};
  & > div {
    background-color: ${(props) => props.theme.vDarkGray};
    height: 100%;
    width: 6px;
    margin: 2px;
    display: inline-block;
    animation: dv-sk-stretchdelay 1.2s infinite ease-in-out;
  }
  & > span {
    font-size: ${(props) => props.theme.fontMedium};
    text-transform: lowercase;
  }
  .rect2 {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
  }

  .rect3 {
    -webkit-animation-delay: -1s;
    animation-delay: -1s;
  }

  .rect4 {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
  }

  .rect5 {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
  }

  @-webkit-keyframes dv-sk-stretchdelay {
    0%,
    40%,
    100% {
      -webkit-transform: scaleY(0.4);
    }
    20% {
      -webkit-transform: scaleY(1);
    }
  }

  @keyframes dv-sk-stretchdelay {
    0%,
    40%,
    100% {
      transform: scaleY(0.4);
      -webkit-transform: scaleY(0.4);
    }
    20% {
      transform: scaleY(1);
      -webkit-transform: scaleY(1);
    }
  }
`;
export const LoaderBox = styled.div `
  position: fixed;
  background: rgba(0, 0, 0, 0.1);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  width: 100%;
  padding-top: 0;
  align-items: center;
`;
const Inner = styled.div `
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;
`;
const Loader = ({ text, className = '' }) => (React.createElement(LoaderBox, { className: `advancedLoader ${className}` },
    React.createElement(Inner, null,
        React.createElement("span", { className: "loading-text" }, text),
        React.createElement(Spinner, { className: "spinner" },
            React.createElement("div", { className: "rect1" }),
            React.createElement("div", { className: "rect2" }),
            React.createElement("div", { className: "rect3" }),
            React.createElement("div", { className: "rect4" }),
            React.createElement("div", { className: "rect5" })))));
export default Loader;
